"use client";

import React from "react";
import EmailVerificationGuard from "@/components/auth/EmailVerificationGuard";
import TeacherBookingGuard from "@/components/auth/TeacherBookingGuard";

export default function BookingLayout({ children }: { children: React.ReactNode }) {
  return (
    <EmailVerificationGuard>
      <TeacherBookingGuard>{children}</TeacherBookingGuard>
    </EmailVerificationGuard>
  );
}
